import { render, staticRenderFns } from "./UserSelection.vue?vue&type=template&id=4c842cb4&scoped=true"
import script from "./UserSelection.vue?vue&type=script&lang=js"
export * from "./UserSelection.vue?vue&type=script&lang=js"
import style0 from "./UserSelection.vue?vue&type=style&index=0&id=4c842cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c842cb4",
  null
  
)

export default component.exports